<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
    v-if="!storeData.id"
      @dataAvailable="
        data => {
          storeData = data || {}
        }
      "
      :searchQuery="{ storeId: this.$route.params.storeId }"
      contentId="storeData"
    />
    <!-- {{ storeData }}
    {{ storeId }} -->
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="flex items-center gap-2">
        <div class="w-20 h-20" v-if="storeData.logo">
          <img
            :src="storeData.logo"
            alt=""
            class="w-full h-full bg-white p-1 rounded-full shadow-lg object-cover"
          />
        </div>
        <div class="text-2xl title-color">
          {{ storeData.storeName }}
        </div>
      </div>

      <div class="bg-[#f4f4f5] py-3 pt-6">
        <div class="flex justify-between items-center">
          <div
            class="w-full md:w-auto grid grid-cols-2 md:flex gap-4 p-1 bg-white rounded-2xl"
          >
            <router-link
              :to="tab.path"
              class="relative px-4 py-2 rounded-xl flex items-center justify-center"
              v-for="(tab, i) in tabs"
              :key="i"
            >
              <div
                :class="{
                  'w-full h-full bg-primary': activeTab == tab.id,
                  'w-0 h-0 bg-transparent': activeTab !== tab.id,
                }"
                class="duration-300 absolute rounded-xl"
              ></div>
              <div
                class="relative"
                :class="{
                  'text-white': activeTab == tab.id,
                  '': activeTab !== tab.id,
                }"
              >
                {{ tab.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'

export default {
  name: 'homeComponent',
  components: { DataGetter },
  data() {
    return {
      accountsLoading: true,
      storeId: '',
      storeData: {},
      tabs: [
        {
          name: 'Statistiques',
          id: 'storeStats',
          path: `/stores/${this.$route.params.storeId}`,
        },
        {
          name: 'Produits',
          id: 'storeProducts',
          path: `/stores/${this.$route.params.storeId}/products`,
        },
        // {
        //   name: 'Paiements',
        //   id: 'storePayments',
        //   path: `/stores/${this.$route.params.storeId}/payments`,
        // },
        // {
        //   name: 'Transferts',
        //   id: 'storeWithdrawalsMomo',
        //   path: `/stores/${this.$route.params.storeId}/transfer`,
        // },
        // {
        //   name: 'Reversements',
        //   id: 'storeWithdrawalsBank',
        //   path: `/stores/${this.$route.params.storeId}/withdrawals`,
        // },
        // {
        //   name: 'Discussion',
        //   id: 'storeChat',
        //   path: `/stores/${this.$route.params.storeId}/chat`,
        // },
      ],
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {},
  computed: {
    activeTab() {
      return this.$route.name
    },
  },
}
</script>
